/**
 * @prettier
 * @author Alexander Nagelberg
 * @author Alex Clary
 *
 **/
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import FundingFeeNav from '../components/FundingFeeNav'
import FundingFeeBody from '../components/FundingFeeBody'

const FundingFee = props => {
  const [doesWebLgySessionExist, setDoesWebLgySessionExist] = useState(false)

  /* In the refund gear, there are occasional links to specifici WebLGY loans. The problem is that WebLGY 
  requires a session to be created before it will accept any direct URLs. Therefore we create a session 
  (if one does not already exist) when the gear is loaded. Thus, any future links to WebLGY in this gear 
  will work correctly. Possibly it may be useful in the future to have this functionality for other gears, 
  but out of an abundance of caution towards the performance impact I only made this request when the Funding 
  Fee gear is opened. Keep in mind that errors in the request are not handled in any way, so as to silently 
  fail for a number of reasons (misconfigured users, local WebLGY not running, etc.) */
  useEffect(() => {
    if (!doesWebLgySessionExist) {
      fetch('/lgyhub/WebLGY/UserLogin.do')
      setDoesWebLgySessionExist(true)
    }
  }, [doesWebLgySessionExist])

  return (
    <div className='lgy-funding-fee usa-grid'>
      <FundingFeeNav {...props} />
      <FundingFeeBody />
    </div>
  )
}

const mapStateToProps = state => ({ authorizations: state.currentUser?.authorizations ?? [] })

export default connect(mapStateToProps)(FundingFee)
